/**
 * StagedBadge (ADR-111 D2) — the per-artifact pill that closes the "saved vs.
 * live" visibility gap: the Fleet Editor's authoring surfaces (Agents rail,
 * Skill Studio, Workflows, Files Studio) all render from MC's local /fleet
 * mount, which tracks the fleet's DEPLOYED branch (ADR-100). An artifact that
 * has been approved but not yet taken live is otherwise invisible — it looks
 * identical to one that is actually running.
 *
 * ADR-122 D8: this badge is now the ONLY per-page staleness signal, because the
 * aggregate /workflows banner it used to accompany is retired (its question is
 * answered properly by the Ready worklist on Updates). That makes this the
 * surviving protection for the incident that motivated both — an operator
 * deleted 3 activities, the deletion sat unapplied, the page read the deployed
 * branch, and they kept running for 2 days. The badge is strictly more precise
 * than the count ever was: /api/fleet/pending-paths includes deletions, so the
 * affected artifact is marked on its own row rather than folded into a number.
 *
 * The tooltip is deliberately in operator language (ADR-122 D1). It previously
 * read "Merged to develop, not yet deployed" — three words a fleet owner should
 * never need, describing the plumbing rather than the fact.
 */
export function StagedBadge() {
  return (
    <span
      title="Approved but not yet live — it will start working once these changes are taken live (see Updates)."
      className="shrink-0 text-[10px] px-1.5 py-0.5 rounded font-medium bg-amber-100 text-amber-700"
    >
      staged
    </span>
  )
}
